module.exports = __webpack_public_path__ + "img/login_bsgs.27b95d6b.svg";